import React from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router";

import PrivateRoute from "./components/Private/PrivateRoute";
import HomePage from "./containers/HomePage/HomePage";
import UsersPage from "./containers/UsersPage/UsersPage";
import UserPage from "./containers/UserPage/UserPage";
import RolesPage from "./containers/RolesPage/RolesPage";
import RolePage from "./containers/RolePage/RolePage";
import PermissionsPage from "./containers/PermissionsPage/PermissionsPage";
import CreatePermissionPage from "./containers/CreatePermissionPage/CreatePermissionPage";

const Routes = () => (
  <ConnectedSwitch>
    {/* Home (main) route */}
    <Route exact path="/" component={HomePage} />

    {/* Routes requiring login */}
    <PrivateRoute path="/users" component={UsersPage} />
    <PrivateRoute path="/user/:id" component={UserPage} />
    <PrivateRoute path="/roles" component={RolesPage} />
    <PrivateRoute path="/role/:id" component={RolePage} />
    <PrivateRoute path="/permissions" component={PermissionsPage} />
    <PrivateRoute path="/permission/create" component={CreatePermissionPage} />

    {/* Routes */}

    {/* Catch all route */}
    <Route component={HomePage} />
  </ConnectedSwitch>
);

// This is needed for react-router-redux
const ConnectedSwitch = connect()(Switch);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js